// ── Design Tokens ─────────────────────────────────────────────
export const GOLD = "#C9A84C";
export const GOLD_L = "#E8C97A";
export const GOLD_D = "#9A7A2E";
export const NAVY = "#061221";
export const NAVY_M = "#0D2137";
export const NAVY_L = "#1A3A5C";
export const GEO = "Georgia, 'Times New Roman', serif";

export const TH = (dark) => ({
  bg: dark ? NAVY : "#F5F0E8",
  sur: dark ? NAVY_M : "#FFFFFF",
  s2: dark ? NAVY_L : "#F0EBE0",
  bdr: dark ? "rgba(201,168,76,0.2)" : "rgba(154,122,46,0.2)",
  txt: dark ? "#F0E6C8" : "#1A1209",
  t2: dark ? "#8A9BB0" : "#6B5A3A",
  inp: dark ? NAVY_L : "#FAF6EF",
  ib: dark ? "rgba(201,168,76,0.3)" : "rgba(154,122,46,0.3)",
  nav: dark ? "rgba(6,18,33,0.97)" : "rgba(245,240,232,0.97)",
  gold: GOLD,
  acc: dark ? GOLD_L : GOLD_D,
});

// ── Assets ────────────────────────────────────────────────────
export const A = {
  logoHL:
    "https://fortunyone.zendesk.com/hc/theming_assets/01KQSPQSW27B2BKHBX005W6Y72",
  logoHD:
    "https://fortunyone.zendesk.com/hc/theming_assets/01KQSPQQKF2B9GQ1DY8XSPW5FM",
  logoHLL:
    "https://fortunyone.zendesk.com/hc/theming_assets/01KQSPQXV9WQ40M5ZZFTK5VMBA",
  logoHDL:
    "https://fortunyone.zendesk.com/hc/theming_assets/01KQSPQVM9Y6MMTMR6BYX5MJ7W",
  bgDD: "https://fortunyone.zendesk.com/hc/theming_assets/01KQSPSNZ7YS8NJT2E7P9KKBED",
  bgLD: "https://fortunyone.zendesk.com/hc/theming_assets/01KQSPSM9DYV5654M1AQAY60CJ",
  bgDM: "https://fortunyone.zendesk.com/hc/theming_assets/01KQSPTSQXPWQ9XYDYYFZA31K5",
  bgLM: "https://fortunyone.zendesk.com/hc/theming_assets/01KQSPTRCRAP1D0Y5612DFVJH2",
  icD: "https://fortunyone.zendesk.com/hc/theming_assets/01KQSP0206KA0C4503CVVRGMBM",
  icL: "https://fortunyone.zendesk.com/hc/theming_assets/01KQSP00B6H27114SZ59R7BJZA",
};
